import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import * as graphql from '@treams/treams-network';
import { FlexGap, Heading3, NoPrintWrapper, Paragraph, tokens } from '@treams/treams-ui';

import FeedbackRadarChart from '../FeedbackRadarChart';
import { FeedbackRecipients, FeedbackRecipientsSkeleton } from './FeedbackRecipients';

const SidebarContainer = styled(FlexGap)`
	background: ${tokens.surface.secondary};
	box-sizing: border-box;
	width: 100%;
	flex-direction: column;
	padding: ${tokens.padding.container}px;
	gap: ${tokens.gap.group}px;
`;

export function FeedbackResultsSidebar(props: { request: graphql.FeedbackRequest }) {
	const { t } = useTranslation();
	const showChart = props.request.questions.some(
		(question) =>
			question.type !== graphql.FeedbackQuestionType.Text &&
			question.type !== graphql.FeedbackQuestionType.MultipleChoice,
	);

	return (
		<NoPrintWrapper>
			<SidebarContainer minHeight={['0', '0', '100%']}>
				{showChart && (
					<FlexGap flexDirection="column" gap={tokens.gap.list} width="100%">
						<FlexGap flexDirection="column" gap={tokens.gap.inline}>
							<Heading3>{t('feedback.results.questions.chart.title')}</Heading3>
							<Paragraph small>{t('feedback.results.questions.chart.description')}</Paragraph>
						</FlexGap>
						<FeedbackRadarChart request={props.request} />
					</FlexGap>
				)}
				<FeedbackRecipients request={props.request} />
			</SidebarContainer>
		</NoPrintWrapper>
	);
}

export function FeedbackResultsSidebarSkeleton() {
	const { t } = useTranslation();

	return (
		<NoPrintWrapper>
			<SidebarContainer minHeight={['0', '0', '100%']}>
				<FlexGap flexDirection="column" gap={tokens.gap.list} width="100%">
					<FlexGap flexDirection="column" gap={tokens.gap.inline}>
						<Heading3>{t('feedback.results.questions.chart.title')}</Heading3>
						<Paragraph small>{t('feedback.results.questions.chart.description')}</Paragraph>
					</FlexGap>
					<FeedbackRadarChart.Skeleton />
				</FlexGap>
				<FeedbackRecipientsSkeleton />
			</SidebarContainer>
		</NoPrintWrapper>
	);
}
